export default {
  header: 'Opuścić stronę z niezapisanymi zmianami?',
  message: 'Opuszczenie tej strony usunie wszystkie niezapisane zmiany.',
  leavePage: 'Opuść stronę',
  stay: 'Zostań',
};
